module.exports = __webpack_public_path__ + "img/crystal-blast.2798d5c4.png";